export default function buildBaseEndpoint({ view, tab, isEvidence, isMapping, mappingContent }) {
  //  Tab segment logic
  let tabSegment = tab?.toLowerCase().replace(/s$/, '');
  tabSegment = tabSegment === 'chemical' ? 'chem' : tabSegment;

  // View segment logic
  let viewSegment = '' as string;
  viewSegment = view === 'ALL' ? '/all' : '/summary';
  viewSegment = ['VDA', 'GDA'].includes(tab as string) ? '/summary' : viewSegment;
  viewSegment = tab === 'DDA' ? '' : viewSegment; // DDA has its own backend pattern
  viewSegment = isEvidence === true ? '' : viewSegment;

  // If mappingContent is provided, override segments
  if (isMapping && mappingContent) {
    tabSegment = mappingContent.tabSegment ?? tabSegment;
    viewSegment = mappingContent.viewSegment === '/all' ? '/all' : '/summary';
    viewSegment = isEvidence === true ? '' : viewSegment;
    viewSegment = tabSegment.includes('shared') ? '' : viewSegment;
    if (isEvidence) {
      viewSegment = '';
    } else if (mappingContent.viewSegment === '/all') {
      viewSegment = mappingContent.viewSegment;
    }
  }

  const baseEndpoint = `api/${tabSegment}${viewSegment}`;

  return baseEndpoint;
}
